module.exports = __webpack_public_path__ + "static/self-compassion-247969ef3b94fe96fa8060deb84ea249.jpg";